module.exports = __webpack_public_path__ + "static/media/icn_ca.f35ddf9b.svg";